import React, { Component } from 'react';
import Translate from 'react-translate-component';
import './Text.scss';

interface IText {
  /**
  * The text to be rendered
  */
  content: string | JSX.Element,
  /**
  * The type of div element
  */
  component?: string,
  /**
  * Additional classes use to add custom styles
  */
  className?: string,
  /**
   * additional inline style
   */
  style?: object
  /**
   * if the value has to be translated
   */
  shouldTranslate?: boolean,
  /**
   * translate with props
   */
  translateWith?: object,
  /*
   * Remove the bottom margin
   */
  noMargin?: boolean,
  /*
   * Click handler
   */
  onClick?: () => any,
}

class Text extends Component<IText, any> {
  render() {
    const { 
      content, 
      component = 'p', 
      className = "", 
      shouldTranslate = true, 
      translateWith = {}, 
      noMargin = false, 
      onClick = null,
      style = {}
    } = this.props;

    const margin = noMargin ? "mb0" : "";

    if (shouldTranslate) {
      return (
        <Translate
          content={content}
          component={component}
          with={translateWith}
          className={`cc-text ${margin} ${className}`}
          onClick={onClick}
          style={style}
        />
      );
    }

    //first letter MUST BE capitalized in order to bind dinamically the component
    let Component: any = component;
    return (
      <Component className={`cc-text ${margin} ${className}`} style={style} onClick={onClick}>
        {content}
      </Component>
    );
  }
}

export default Text;
